import moment from 'moment';
import * as queryString from 'query-string';
import { NewUserOnboardingIDs } from '../../components/Analytics/testIDConfig';

export const ThirdPartyConnections = [
    {
        id: 'tcid',
        type: 'Tennis Connect',
        partnershipLogo: '/img/logos/activate/ta-partnership.svg',
        title: 'Connect Tennis ID with UTR Sports',
        description: 'To activate your UTR Rating, connect your Tennis ID to a UTR Sports account. If you don’t have an account, you can create one for free.',
        // TODO: use isoCountryCode2
        country: 'Australia',
        countryCode: 'AU',
        genderTypes: {
            male: 'M',
            female: 'F',
            not_known: '',
        },
        additionalInfoDisplayFields: [
            {
                field: 'tennisId',
                placeholder: 'Tennis Id',
                label: 'Tennis Id',
                displayProperty: 'thirdPartyId',
                testid: `${NewUserOnboardingIDs.PITennisId.component}-${NewUserOnboardingIDs.PITennisId.location}-${NewUserOnboardingIDs.PITennisId.id}`,
            },
        ],
        errorDescription: 'An error has occurred when activating your UTR Rating with Tennis Australia. Please contact the Tennis Australia support team via <a href="mailto: play@tennis.com.au">play@tennis.com.au</a>.',
        errorRedirectUrl: 'https://matchcentre.tennis.com.au/dashboard',
    },
];

export const UtrActivationUnderAgeLimit = 15;

export const isThirdPartyTypeSupported = (id) => {
    return ThirdPartyConnections.findIndex((connection) => connection.id === id) > -1;
};

export const getThirdPartyConnection = (id) => {
    return ThirdPartyConnections.find((connection) => connection.id === id);
};

export const isUtrActivationInProgress = (activateUtrData = {}) => {
    const { activationType, activationToken } = activateUtrData;
    return !!activationType && !!activationToken;
};

const PathsToDisplayActivateUtrNotification = [
    '/',
    '/login',
    '/join',
];

export const shouldDisplayActivateUtrNotification = (activateUtrData, locationPathName) => {
    return isUtrActivationInProgress(activateUtrData) && PathsToDisplayActivateUtrNotification.includes(locationPathName);
};

export const getAdditionalInfoDefaultValues = (activateUtrData = {}) => {
    const thirdPartyConnection = getThirdPartyConnection(activateUtrData.activationType);
    const userDobObject = activateUtrData?.user?.dateOfBirth && moment(activateUtrData.user.dateOfBirth);

    const displayFieldValues = thirdPartyConnection.additionalInfoDisplayFields.reduce((values, displayField) => {
        return {
            ...values,
            [displayField.field]: activateUtrData.user[displayField.displayProperty],
        };
    }, {});

    return {
        firstName: activateUtrData.user.firstName,
        lastName: activateUtrData.user.lastName,
        gender: thirdPartyConnection?.genderTypes[activateUtrData.user.gender],
        day: userDobObject?.date(),
        month: userDobObject?.format('MMMM'),
        year: userDobObject?.year(),
        phoneCountryCode: thirdPartyConnection.countryCode,
        ...displayFieldValues,
    };
};

export const getExtraDisplayFieldsForAdditionInfo = (activateUtrData) => {
    const thirdPartyConnection = getThirdPartyConnection(activateUtrData.activationType);

    return thirdPartyConnection.additionalInfoDisplayFields;
};

export const shouldCallConnectPlayerThirdPartyId = (activateUtrData) => {
    return !activateUtrData.redirectToken && !activateUtrData.isLoading && !activateUtrData.isErrored;
};

export const getUserAge = (activateUtrData) => {
    const userDobObject = moment(activateUtrData.user.dateOfBirth);
    return moment().diff(userDobObject, 'years');
};

export const shouldNavigateToRedirectUrl = (activateUtrData) => {
    if (isUtrActivationInProgress(activateUtrData)) {
        return !activateUtrData.isLoading && !activateUtrData.isErrored && activateUtrData.redirectToken;
    }

    return false;
};

export const getRedirectUrl = (activateUtrData) => {
    const parsedRedirectUrl = new URL(activateUtrData.user?.redirectUrl);
    const parsed = queryString.parse(parsedRedirectUrl.search);
    const queryParams = {
        ...parsed,
        token: activateUtrData.redirectToken,
    };

    const absoluteUrl = `${parsedRedirectUrl.origin}${parsedRedirectUrl.pathname}`;
    return `${absoluteUrl}${Object.keys(queryParams).length > 0 ? `?${queryString.stringify(queryParams, { encode: true })}` : ''}`;
};
